var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z",
    fill: "#FD5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7764 10.2121C20.1749 10.6052 20.1793 11.2469 19.7862 11.6454L11.6095 19.9347C11.6045 19.9399 11.5995 19.9451 11.5944 19.9502L11.5815 19.9631C11.1869 20.3583 10.5468 20.3597 10.1504 19.9663C9.75396 19.5729 9.75056 18.9328 10.1428 18.5352L18.3431 10.2219C18.7362 9.82344 19.3779 9.81905 19.7764 10.2121Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2616 10.1063C10.6688 9.72214 11.3103 9.74083 11.6944 10.148L19.6844 18.6174C19.6894 18.6225 19.6943 18.6277 19.6992 18.633L19.7117 18.6464C20.0925 19.055 20.0709 19.6947 19.6634 20.0767C19.256 20.4587 18.6163 20.4391 18.233 20.0328L10.2199 11.539C9.83581 11.1318 9.85449 10.4904 10.2616 10.1063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.0e769e169b3e65c8999a782191c42228.svg";
export { ForwardRef as ReactComponent };